module.exports = __webpack_public_path__ + "static/media/mt6.540fda88.jpg";